// useLaoQr.ts
import { useMutation } from "@tanstack/react-query";
import { generateLaoQr } from "../repositories/payment.repository";

export const useGenerateLaoQr = () => {
  return useMutation({
    mutationFn: ({
      paymentChannelId,
      orderId,
    }: {
      paymentChannelId: string;
      orderId: string;
    }) => generateLaoQr(paymentChannelId, orderId),
    onSuccess: (data) => {
      console.log("🎯 QR generation successful:", data);
    },
    onError: (error) => {
      console.error("💥 QR generation failed:", error);
    },
  });
};
